
import { Injectable } from '@nestjs/common';
import { Raw } from 'typeorm';
import { ConsumeTokenRequest } from './dto/consume-token.request';
import { EmployeeFreebiesAssignRequest } from './dto/employee-freebies-assign.request';
import { EmployeeFreebiesRepo } from './repository/employee-freebies.repository';
import { FreebiesConsumptionRepo } from './repository/freebies-consumption.repository';
import { TokensHelperService } from './tokens-helper.service';
import { TokensAdapter } from './tokens.adapter';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import {CategoryWiseTokenConsumptionModel, DateWiseTokenConsumptionModel, EmployeeTokenConsumptionReportModel, EmployeeTokenConsumptionReportRequest, EmployeeTokenConsumptionReportResponse, SummaryReportModel, SummaryReportRequest, SummaryReportResponse, TokenPrintModel, TokenPrintResponse } from '@gtpl/shared-models/canteen-management';
import { CommonResponse, EmployeeDto, EmployeeResponseModel } from '@gtpl/shared-models/masters';
import { HrmsEmpDetService } from '@gtpl/shared-services/masters';
import { FreebiesServices } from '../freebies/freebies.service';
import { FreebieRepo } from '../freebies/repository/freebies.repository';
import { EmployeeFreebiesEntity } from './entity/employee-freebies.entity';
import moment from 'moment';
import { Cron, CronExpression } from '@nestjs/schedule';

@Injectable()
export class TokenConsumptionService {
    constructor( 
        private tokenHelperService: TokensHelperService,
        private employeeFreebieRepo: EmployeeFreebiesRepo,
        private freebieConsumptionRepo: FreebiesConsumptionRepo,
        private tokensAdapter: TokensAdapter,
        private empService : HrmsEmpDetService,
        private freebiesService : FreebiesServices,
        private freebieRepo : FreebieRepo

    ) {

    }

    /**
     * consumes the token 
     * @param consumeTokenRequest 
     */
    async consumeToken(consumeTokenRequest: ConsumeTokenRequest): Promise<TokenPrintResponse> {
        // const empInfo: EmployeeModel = await this.tokenHelperService.getEmployeeRecordByEmpRfId(consumeTokenRequest.employeeRfId, false);
        // if (!empInfo) {
        //     throw new ErrorResponse(0, 'The scanning id card is invalid');
        // }
        // this.printUsbReceipt(new TokenPrintModel('1001', 'Prince of Persia', 'Meal', 'Tue May 24 2022 00:42:23', 15, 12, '2', '0', 75.00));
        // return null;
        return await this.consumeEmployeeToken(consumeTokenRequest);
    }

    /**
     * 
     * @param consumeTokenRequest 
     * @returns 
     */
    async consumeEmployeeToken(consumeTokenRequest: ConsumeTokenRequest): Promise<TokenPrintResponse> {
        const transManager = new GenericTransactionManager();
        try {
            const deviceCode = '';
            const empCode = consumeTokenRequest.employeeCode;
            //  const empCode = 'SX0198'
            // check and get the employee based on the rf id
            const empInfo: EmployeeResponseModel = await this.tokenHelperService.getEmployeeRecordByEmpCode(empCode);
            console.log('empinfo',empInfo)
            const companyId = 1;
            // get the current hour to categorize the incoming token request is for what
            const currHour = new Date().getHours();
            const currYear = new Date().getFullYear();
            const currMon = new Date().getMonth() + 1;
            const currDate = new Date().getDate();
            const currMinutes = new Date().getMinutes();

            // get the freebie mapping to the hour + company id
            const mappedFreebie = await this.tokenHelperService.getFreebieMappedForCompanyAndHour(companyId, currHour);
            const price = mappedFreebie.unitPrice;
            console.log('**************',mappedFreebie);
            // get the available balance tokens for the employee
            const empFreebieInfo = await this.employeeFreebieRepo.findOne({
                select: ['availableCount', 'employeeFreebiesId', 'originalCount', 'maxConsumptionPerDay'],
                where: { employeeCode: empInfo.data.employeeCode, freebieId: mappedFreebie.freebieId, isActive: true }
            });
            console.log('-------------------',empFreebieInfo);
            if (!empFreebieInfo) {
                throw new ErrorResponse(0, 'No freebies are mapped to the current employee for the current month and current time interval');
            }
            const maxConsumptionPerDay = empFreebieInfo.maxConsumptionPerDay;
            const balTokens = empFreebieInfo.availableCount;
            const consumedTokens = empFreebieInfo.originalCount - balTokens;

            // check how many freebies scanned till now
            const tokensTakenToday = await this.freebieConsumptionRepo.count({
                employeeCode: empCode, freebieCode: mappedFreebie.freebieCode,
                createdAt: Raw(alias => `DATE(created_at) = "${currYear + '-' + currMon + '-' + currDate}" `)
            });
            if (maxConsumptionPerDay <= tokensTakenToday) {
                throw new ErrorResponse(0, 'You have consumed the maximum tokens for the day');
            }
            if (balTokens == 0) {
                throw new ErrorResponse(0, 'Sorry, You have spent all the tokens for the current month');
            }
            // insert the record into the token consumption
            const freebieConsEnt = this.tokensAdapter.getFreebiesConsumptionEntity(
                empInfo.data.employeeId, empCode, empFreebieInfo.employeeFreebiesId, mappedFreebie.freebieCode,
                consumeTokenRequest.employeeCode, currYear, currMon, deviceCode, empInfo.data.employeeName, Number(empInfo.data.departmentId), mappedFreebie.freebieCategory, mappedFreebie.unitPrice,mappedFreebie.isActive
            );
            await transManager.startTransaction();
            await transManager.getCustomRepository(FreebiesConsumptionRepo).save(freebieConsEnt);
            await transManager.getCustomRepository(EmployeeFreebiesRepo).decrement({ employeeFreebiesId: empFreebieInfo.employeeFreebiesId }, "availableCount", 1);
            await transManager.completeTransaction();

            // get the print info and return it back
            const printInfo = new TokenPrintModel(
                empInfo.data.employeeCode, empInfo.data.employeeName, mappedFreebie.freebieCategory, new Date().toLocaleString(), consumedTokens + 1,
                balTokens - 1, mappedFreebie.startHour.toString(), mappedFreebie.endHour.toString(), price
            );

            // print the print to the printer
            //this.printUsbReceipt(printInfo);
            this.printReceipt(printInfo);
            return new TokenPrintResponse(true, 0, 'Token consumed successfully', printInfo);
        } catch (error) {
            throw error;
        } finally {
            await transManager.releaseTransaction();
        }
    }


    async printUsbReceipt(printInfo: TokenPrintModel): Promise<boolean> {
        const escpos = require('escpos');
        escpos.USB = require('escpos-usb');
        console.log(escpos.USB.findPrinter());
        const device = new escpos.USB(8137,8214);
        const options = { encoding: 'cp857' }
        // encoding is optional

        // get the input details
        const empName = printInfo.employeeName;
        const empCode = printInfo.employeeCode;
        const fbCat = printInfo.freebieCategory;
        const consumedTokens = printInfo.consumedTokens;
        const balTokens = printInfo.availableTokens;
        const price = printInfo.price;

        const printer = new escpos.Printer(device);
        device.open(function (error) {
            printer.font('a')
                .align('ct')
                .style('bu')
                .size(0.5, 0.5)
                .text(' SANDHYA AQUA ')
                .text('*********************************************')
                .text(fbCat + ' RECEIPT')
                .feed()
                .align('lt')
                // .barcode('1234567', 'EAN8')
                // .table(["Emp Name :", empName, "Emp Code : ", empCode])
                // .table(["Consumed : ", consumedTokens, "Avl Tokens : ", balTokens])
                // .table(["Unit Price : ", price+' Rs', "Date : ", printInfo.tokenDate])
                // .table(["Emp Name   :", empName])
                // .table(["Emp Code   : ", empCode])
                // .table(["Consumed   : ", consumedTokens])
                // .table(["Avl Tokens : ", balTokens])
                // .table(["Unit Price : ", price+' Rs'])
                // .table(["Date       : ", printInfo.tokenDate])
                .control('ht').text("Emp Name   : " + empName)
                .control('ht').text("Emp Code   : " + empCode)
                .control('ht').text("Consumed   : " + consumedTokens)
                .control('ht').text("Avl Tokens : " + balTokens)
                .control('ht').text("Type       : " + 'Regular')
                .control('ht').text("Date       : " + printInfo.tokenDate)
                .feed()
                .control('ht').text('Please give feedback on food to')
                .align('ct').text('HR Admin')
                .feed()
                .text('*********************************************')
                .feed()
                // .tableCustom(
                //   [
                //     { text:"Left", align:"LEFT", width:0.33, style: 'B' },
                //     { text:"Center", align:"CENTER", width:0.33},
                //     { text:"Right", align:"RIGHT", width:0.33 }
                //   ],
                //   { size: [1, 1] } // Optional
                // )
                .cut().close();
        });

        return true;
    }

    async printReceipt(printInfo: TokenPrintModel): Promise<boolean> {
        const category = printInfo.freebieCategory;
        const escpos = require('escpos');
        escpos.Network = require('escpos-network');
        const device = new escpos.Network('192.168.0.100');
        const options = { encoding: 'cp857' }
        // encoding is optional

        // get the input details
        const empName = printInfo.employeeName;
        const empCode = printInfo.employeeCode;
        const fbCat = printInfo.freebieCategory;
        const consumedTokens = printInfo.consumedTokens;
        const balTokens = printInfo.availableTokens;
        const price = printInfo.price;
        

        const printer = new escpos.Printer(device);
        device.open(function (error) {
            printer.font('a')
                .align('ct')
                .style('bu')
                .size(0.5, 0.5)
                .text(' SANDHYA AQUA ')
                .text('*********************************************')
                .text(fbCat + ' RECEIPT')
                .feed()
                .align('lt')
                .control('ht').text("Emp Name   : " + empName)
                .control('ht').text("Emp Code   : " + empCode)
                .control('ht').text("Consumed   : " + consumedTokens)
                .control('ht').text("Avl Tokens : " + balTokens)
                .control('ht').text("Type       : " + 'Regular')
                .control('ht').text("Date       : " + printInfo.tokenDate)
                .feed()
                .control('ht').text('Please give feedback on food to')
                .align('ct').text('HR Admin')
                .text('*********************************************')
                .feed()
                .cut().close();
        });

        return true;
    }

    /**
     * 
     * @param consumeTokenRequest 
     * @returns 
     */
    async consumeVisitorToken(consumeTokenRequest: ConsumeTokenRequest): Promise<TokenPrintResponse> {
        const transManager = new GenericTransactionManager();
        try {
            const deviceCode = '';
            // get the current hour to categorize the incoming token request is for what
            const currHour = new Date().getHours();
            const currYear = new Date().getFullYear();
            const currMon = new Date().getMonth();
            // insert the record into the token consumption
            const freebieConsEnt = this.tokensAdapter.getFreebiesConsumptionEntity(0, '', 0, '', consumeTokenRequest.employeeCode, currYear, currMon, deviceCode, 'VISITOR', null, null, 0,true);
            await transManager.startTransaction();
            await transManager.getCustomRepository(FreebiesConsumptionRepo).save(freebieConsEnt);
            await transManager.completeTransaction();

            // get the print info and return it back
            const printInfo = new TokenPrintModel(
                'VISITOR', 'VISITOR', '', new Date().toString(), 0, 0, 'NA', 'NA', 0
            );
            return new TokenPrintResponse(true, 0, 'Token consumed successfully', printInfo);
        } catch (error) {
            throw error;
        } finally {
            await transManager.releaseTransaction();
        }
    }

    /**
 * gets the employee token consumption report
 * @param empTokenConsReportReq
 */
    async getEmployeeTokenConsumptionReport(empTokenConsReportReq: EmployeeTokenConsumptionReportRequest): Promise<EmployeeTokenConsumptionReportResponse> {
        const fromDate = empTokenConsReportReq.fromDate;
        const toDate = empTokenConsReportReq.toDate;
        const fbCat = empTokenConsReportReq.freebieCategory;
        const deptId = empTokenConsReportReq.departmentId;

        const empResponseMap = new Map<number, Map<number, EmployeeTokenConsumptionReportModel>>();
        const records = await this.freebieConsumptionRepo.getTokenConsumptionRecordsByDate(fromDate, toDate, deptId, fbCat);
        if (records.length == 0) {
            throw new ErrorResponse(0, 'No data found');
        }
        const empsInfo = await this.tokenHelperService.getAllEmployees();
        const empsInfoMap = new Map<number, EmployeeDto>();
        empsInfo.forEach(emp => empsInfoMap.set(emp.employeeId, emp));
        const deptInfo = await this.tokenHelperService.getAllDepartments();
        const deptNameMap = new Map<number, string>();
        deptInfo.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));

        for (const record of records) {
            const empId = Number(record.employee_id);
            const empFreebieId = Number(record.employee_freebies_id);
            const empInfo = empsInfoMap.get(empId);
            if (!empResponseMap.has(empInfo.employeeId)) {
                empResponseMap.set(empInfo.employeeId, new Map<number, EmployeeTokenConsumptionReportModel>());
            }
            if (!empResponseMap.get(empId).has(empFreebieId)) {
                const empFreebieInfo = await this.employeeFreebieRepo.findOne({
                    select: ['freebieId', 'availableCount', 'employeeFreebiesId', 'originalCount'],
                    where: { employeeFreebiesId: empFreebieId, isActive: true }
                });
                const freebieInfo = await this.tokenHelperService.getFreebieRecordByFreebieId(empFreebieInfo.freebieId);
                // price = Math.round(record.count * Number(freebieInfo.unitPrice));
                empResponseMap.get(empId).set(empFreebieId, new EmployeeTokenConsumptionReportModel(
                    empInfo.employeeName, empInfo.employeeCode, deptNameMap.get(Number(empInfo.departmentId)), freebieInfo.freebieCategory, [], freebieInfo.unitPrice, 0, 0
                ));
            }
            empResponseMap.get(empId).get(empFreebieId).totalCost += Number(record.unit_price);
            empResponseMap.get(empId).get(empFreebieId).dateWiseConsumption.push(new DateWiseTokenConsumptionModel(record.date, record.count));
        }
        const tokensModelArray: EmployeeTokenConsumptionReportModel[] = [];
        empResponseMap.forEach(empCons => empCons.forEach(freebieCons => tokensModelArray.push(freebieCons)));
        return new EmployeeTokenConsumptionReportResponse(true, 0, 'Employee report retrieved successfully', tokensModelArray);
    }

    /**
     * 
     * @param tokenConsSummaryReportReq 
     * @returns 
     */
    async getTokenConsumptionSummaryReport(tokenConsSummaryReportReq: SummaryReportRequest): Promise<SummaryReportResponse> {
        const fromDate = tokenConsSummaryReportReq.fromDate;
        const toDate = tokenConsSummaryReportReq.toDate;

        const sumryResponseMap = new Map<string, CategoryWiseTokenConsumptionModel[]>(); // date => freebie wise count
        const records = await this.freebieConsumptionRepo.getTokenConsumptionByDate(fromDate, toDate);
        console.log(records);
        if (records.length == 0) {
            throw new ErrorResponse(0, 'No data found');
        }
        for (const record of records) {
            if (!sumryResponseMap.has(record.date)) {
                sumryResponseMap.set(record.date, []);
            }
            sumryResponseMap.get(record.date).push(new CategoryWiseTokenConsumptionModel(record.freebie_category, record.count));
        }
        const tokensModelArray: SummaryReportModel[] = [];
        sumryResponseMap.forEach((dateWiseCons, key) => {
            let total = 0;
            dateWiseCons.forEach(freebie => total += Number(freebie.tokensConsumed));
            tokensModelArray.push(new SummaryReportModel(key, dateWiseCons, total));
        });
        return new SummaryReportResponse(true, 0, 'Summary report retrieved successfully', tokensModelArray);
    }
     
    @Cron(CronExpression.EVERY_1ST_DAY_OF_MONTH_AT_MIDNIGHT)
    async freebiesMapping () :Promise<CommonResponse>{
          const empData = await this.empService.getAllActiveEmployees()
          const freebiesData = await this.freebieRepo.find({where : {isActive : 1}})
          const empFreebieArr : EmployeeFreebiesEntity[] = [];
          for(const emp of empData.data){
              for(const freebie of freebiesData){
                 const entityObj =new EmployeeFreebiesEntity()
                 entityObj.employeeId = emp.employeeId
                 entityObj.employeeCode = emp.employeeCode
                 entityObj.freebieCode = freebie.freebieCode
                 entityObj.freebieId = freebie.freebieId
                 entityObj.maxConsumptionPerDay = 1
                 entityObj.originalCount = 31
                 entityObj.month = moment().month() + 1
                 entityObj.availableCount = 31
                 entityObj.year = moment().year()
                 empFreebieArr.push(entityObj)
              }
          }
          const query = `DELETE FROM erpx_dev_cms.employee_freebies WHERE month = ${moment().month()}`
          const save = await this.employeeFreebieRepo.save(empFreebieArr)
        if(save){
            return new CommonResponse(true,11,'Data updated successfully',save)
        }else{
            return new CommonResponse(false,0,'something went erong')
        }
    }
}